import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConsentsFormService} from '../../../services/consents-form.service';

@Component({
    selector: 'app-notifications-announcements-dialog',
    templateUrl: './notifications-announcements-dialog.component.html',
    styleUrls: ['./notifications-announcements-dialog.component.scss']
})
export class NotificationsAnnouncementsDialogComponent implements OnInit {
    notifications: any;
    user: any;
    displayColumns = ['mode', 'formTitle', 'displayName', 'deadline', 'notificationDate', 'actions'];

    constructor(public dialogRef: MatDialogRef<NotificationsAnnouncementsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private consentsFormService: ConsentsFormService) {
        this.notifications = data.notifications;
        this.user = data.currentUser;
    }

    ngOnInit(): void {
        console.log(this.notifications);
    }

    close() {
        this.dialogRef.close();
    }

    async navigate(notification: any) {
        const child = {id: notification.childId};
        await this.consentsFormService.showConsent(notification, this.user, child);
        this.close();
    }

    getIcon(mode: string) {
        if (mode === 'affirmation') {
            return 'article';
        } else if (mode === 'consent') {
            return 'assignment';
        } else {
            return 'notification';
        }
    }

    getColor(mode: string) {
        if (mode === 'affirmation') {
            return '#fcb502';
        } else if (mode === 'consent') {
            return '#08044c';
        } else {
            return 'red';
        }
    }
}
